import { render } from "./BillInvoice.vue?vue&type=template&id=38492fa3&scoped=true"
import script from "./scripts/bill-invoice.ts?vue&type=script&language=ts&lang=js"
export * from "./scripts/bill-invoice.ts?vue&type=script&language=ts&lang=js"

import "./BillInvoice.vue?vue&type=style&index=0&id=38492fa3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38492fa3"]])

export default __exports__